import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Indexx from './components/Indexx';
import Home from './components/Home'
import Verifi from './components/Verifi';

function App() {
  return (
    <div className="App">
     <BrowserRouter>
      <Routes>
        <Route path="/" element={<Indexx /> } />
        <Route path="/verify" element={<Verifi /> } />
        <Route path="/home" element={<Home /> } />

      </Routes>
     </BrowserRouter>
    </div>
  );
}

export default App;
